<template>
  <section class="snapshots">
    <div class="snapshots__header">
      <span
          class="btn-success btn btn-success text-center"
          @click.prevent="new_snapshot()"
      >
        {{ translate('snapshot.to_add') }}
      </span>
    </div>
    <div class="response_table">
      <table>
        <thead>
          <tr>
            <th scope="col"> ID </th>
            <th scope="col"> Username </th>
            <th scope="col"> TS </th>
            <th scope="col"> Status </th>
            <th scope="col"> Orders </th>
          </tr>
        </thead>
        <tbody>
          <tr
              v-for="(snapshot, snapshot_key) in snapshots_list"
              :key="snapshot_key"
              @click="show_modal(snapshot)"
          >
            <td data-label="ID" >
              {{snapshot.id}}
            </td>
            <td data-label="Username" >
              {{snapshot.user_name}}
            </td>
            <td data-label="TS" >
              {{get_date(snapshot.created_at)}}
            </td>
            <td data-label="Status" >
              {{snapshot.status}}
            </td>
            <td data-label="Orders" >
              {{snapshot.order_name}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import SnapshotsModal from './SnapshotsModal.vue'
import NewSnapshot from "./NewSnapshot.vue";

export default {
  name: 'SnapshotsList',
  props: ['profile'],

  data(){
    return {
      snapshots_list: [],
      this_page: 0,
      rpc_info: {}
    }
  },
  computed:{
    support_rpc(){
      return this.rpc_info.support_rpc
    }
  },
  created() {
    this.init()
  },
  methods: {
    take_snapshot(params){
      if (params.client_order_id === ''){
        params.client_order_id = null
      }
      this.$http.v1.takeDeviceSnapshot( this.profile.id, {...params} ,() => {
        this.global_notify('info', this.translate('snapshot.new_snapshot_success'))
        this.init()
      })
    },
    init(){
      this.$http.v1.getDeviceSnapshotsList( this.profile.id, this.this_page, (response) => {
        this.snapshots_list = response.data.snapshots
      })
    },
    show_modal(data){
      var t = this.$createElement(SnapshotsModal, {
        props: {
          data
        },
        on: {
          close: () => {this.$modal.hide('dynamic-modal') }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },
    new_snapshot(){
      var t = this.$createElement(NewSnapshot, {
        on: {
          take: (param) => {
            this.take_snapshot(param);
            this.$modal.hide('dynamic-modal');
          },
          close: () => {this.$modal.hide('dynamic-modal') }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },
  }
}
</script>

<style lang="scss" scoped>
  .snapshots {
    height: 100%;
    width: 100%;
    &__header {
      text-align: center;
      font-size: 18px;
      height: 50px;
      span{
        height: 40px;
      }
    }
    .response_table{
      padding: 0;
      height: calc(100% - 50px);
      tbody{
        tr{
          cursor: pointer;
          &:hover{
            background-color: #f1f1f1;
          }
        }
      }
    }
  }
</style>
